/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import * as React from "react";
import * as Sentry from "@sentry/react";
import { useParams } from "react-router-dom";
import Button from "../../../../components/Layout/Button/index";
import Modal from "../../../../components/Modal/Modal";
import Typography from "../../../../components/Typography/Typography";
import InputField from "../../../../components/Layout/fieldInput/InputField";
import { SERVICES } from "../../../../components/Layout/Services";
import { get, post } from "../../../../components/Layout/ApiHandler/apihandler";
import { ToastAlertContext } from "../../../../Config/Providers/ToastAlert";
import { AlertStatus } from "../../../../contants";
import AutoCompleteDropdown from "../../../../components/Layout/AutoCompleteDropdown/AutoCompleteDropdown";

export default function UinUpdateModal({ open, onClose, getUinDetails }) {
  const getOptionsForUin = (options, key) =>
    options?.map((opt) => ({
      ...opt,
      label: opt[key].replace(/_/g, " "),
      value: opt[key],
    }));
  const uinType = [
    { name: "PAN CARD", value: "PAN_CARD" },
    { name: "AADHAR CARD", value: "AADHAR_CARD" },
    { name: "VOTER CARD", value: "VOTER_CARD" },
    { name: "DRIVING LICENSE", value: "DRIVING_LICENSE" },
    { name: "PASSPORT", value: "PASSPORT" },
  ];
  const [selectedUinType, setSelectedUinType] = React.useState("");
  const [memberUin, setMemberUin] = React.useState({});
  const [uinValue, setUinValue] = React.useState("");
  const { memberId } = useParams();
  const toast = React.useContext(ToastAlertContext);
  const handleUinValue = (value) => {
    setUinValue(value);
  };
  const getMemberUin = async () => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/uin`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberUin(data.data);
        setUinValue(data?.data[0]?.uin);
        setSelectedUinType(data?.data[0]?.uinType);
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const getMemberUinOnChange = async (uinType) => {
    try {
      const url = `${SERVICES.GET_MEMBER_DETAILS}/${memberId}/uin`;
      const response = await get(url);
      if (response && response.ok) {
        const data = await response.json();
        setMemberUin(data.data);
        const selectedUinEntry = data.data.find(
          (entry) => entry.uinType === uinType,
        );
        if (selectedUinEntry) {
          setUinValue(selectedUinEntry?.uin);
          setSelectedUinType(selectedUinEntry?.uinType);
        } else {
          setUinValue("");
          console.error("No data found for the selected UIN type");
        }
      } else {
        console.error("Failed to fetch Division Type data");
      }
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  const validateUinDetails = () => {
    if (
      selectedUinType === "PAN_CARD" &&
      !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid PAN.\nFor Example: XXXXX9999X`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "AADHAR_CARD" &&
      !/^[2-9]{1}[0-9]{11}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Aadhaar Number.\nFor Example 999999999999`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "VOTER_CARD" &&
      !/^[a-zA-Z0-9 -]{5,20}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Elector's Photo Identity Number.`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "DRIVING_LICENSE" &&
      !/^[a-zA-Z0-9 -]{5,20}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Driving License Number.`,
        AlertStatus.ERROR,
      );
      return false;
    }
    if (
      selectedUinType === "PASSPORT" &&
      !/^[A-Z]{1}[0-9]{7}$/.test(uinValue)
    ) {
      toast.show(
        `Please enter a valid Passport Number.\nFor Example JXXXXXXX`,
        AlertStatus.ERROR,
      );
      return false;
    }
    return true;
  };
  const onSubmit = async () => {
    if (!validateUinDetails()) {
      return;
    }
    const uinData = {
      memberId,
      uin: uinValue,
      uinType: selectedUinType,
    };
    const uinUrl = `${SERVICES.GET_MEMBER_DETAILS}/updateUin`;
    try {
      const response = await post(uinUrl, uinData);
      if (response.ok) {
        const res = await response.json();
        toast.show("Uin details updated successfully", AlertStatus.SUCCESS);
        await getUinDetails();
      }
    } catch (error) {
      Sentry.captureException(error);
    }
    onClose();
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };
  React.useEffect(() => {
    getMemberUin();
  }, []);

  return (
    <Box tabIndex="0" onKeyPress={handleKeyPress}>
      <Modal open={open} onClose={onClose}>
        <Typography
          style={{
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "20px",
          }}
        >
          Update Member Uin deatils
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            options={getOptionsForUin(uinType, "value")}
            label="Uin Type"
            name="uinType"
            value={selectedUinType}
            onChange={(selectedValue) => {
              setSelectedUinType(selectedValue?.value);
              getMemberUinOnChange(selectedValue?.value);
            }}
            inputProps={{ required: true }}
            useHiddenInput
            style={{ width: "350px" }}
          />
          <InputField
            label="Uin No."
            value={uinValue}
            onChange={(event) => {
              const { value } = event.target;
              handleUinValue(value);
            }}
            style={{ width: "350px" }}
            required
          />
        </Box>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          <Button
            onClick={onSubmit}
            width="40%"
            style={{
              marginRight: "10px",
            }}
          >
            Yes
          </Button>
          <Button
            onClick={onClose}
            cancel
            width="40%"
            style={{
              marginRight: "10px",
            }}
          >
            No
          </Button>
        </Box>
      </Modal>
    </Box>
  );
}
